
// Prevent rescroll / enable anchor links
history.scrollRestoration = "manual"

;(function(window, document) {

  const HEADER_OFFSET = 150;

  /**
   * Scrolls the page to the element for the current hash. A card inside the
   * elastic carousel scrolls to its block instead; the carousel itself brings
   * the card into view (see src/anim/components/carousel).
   */
  function scrollToHash(): boolean {
    const id = decodeURIComponent(window.location.hash.slice(1));
    if (!id) {
      return true;
    }

    const element = document.getElementById(id);
    if (!element) {
      return false;
    }

    const target = element.closest<HTMLElement>('.block-carousel-elastic') ?? element;
    const top = target.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;

    window.scrollTo({ top, left: 0, behavior: "smooth" as ScrollBehavior });
    return true;
  }

  if (window.location.hash) {
    setTimeout(() => {
      // Carousel cards only exist once the carousel has rendered
      if (!scrollToHash()) {
        window.addEventListener('carousel-ready', () => { scrollToHash(); }, { once: true });
      }
    }, 1000);
  }

  // In-page anchor links: override the browser's jump with the offset scroll
  window.addEventListener('hashchange', () => { scrollToHash(); });

})(window, document);
